const namespace = 'lyrebird';

const AZURE_COLORS = Object.freeze({
  // Blues
  SKY_BLUE: 'sky-blue',
  SKY_BLUE_TINT_01: 'sky-blue-tint-01',
  SKY_BLUE_TINT_02: 'sky-blue-tint-02',
  SKY_BLUE_TINT_03: 'sky-blue-tint-03',
  SKY_BLUE_SHADE_01: 'sky-blue-shade-01',
  SKY_BLUE_SHADE_02: 'sky-blue-shade-02',
  SKY_BLUE_SHADE_03: 'sky-blue-shade-03',
  // Grays
  SKY_GRAY: 'sky-gray',
  SKY_GRAY_TINT_01: 'sky-gray-tint-01',
  SKY_GRAY_TINT_02: 'sky-gray-tint-02',
  SKY_GRAY_TINT_03: 'sky-gray-tint-03',
  SKY_GRAY_TINT_04: 'sky-gray-tint-04',
  SKY_GRAY_TINT_05: 'sky-gray-tint-05',
  SKY_GRAY_TINT_06: 'sky-gray-tint-06',
  SKY_GRAY_TINT_07: 'sky-gray-tint-07',
  WHITE: 'white',
  // Greens
  MONTEVERDE: 'monteverde',
  GLENCOE: 'glencoe',
  SAGANO: 'sagano',
  // Yellows
  KOLKATA: 'kolkata',
  ERFOUD: 'erfoud',
  BAGAN: 'bagan',
  // Pinks
  BUNOL: 'bunol',
  PETRA: 'petra',
  NARA: 'nara',
  // Purples
  ABISKO: 'abisko',
  VALENSOLE: 'valensole',
  TOCHIGI: 'tochigi',
  // Reds
  PANJIN: 'panjin',
  HILLIER: 'hillier',
  HARBOUR: 'harbour',
});

const APPS = Object.freeze({
  LEGAL: 'legal',
  MARKETING: 'marketing',
});

const COMPONENTS = Object.freeze({
  COOKIE_BANNER: 'CookieBanner',
  FOOTER: 'Footer',
  HEADER: 'Header',
  NOT_FOUND: 'NotFound',
  FOOTER_FLAGS: 'FooterFlags',
});

const BACKPACK_COLORS = Object.freeze({
  SURFACE_SUBTLE_DAY: 'surface-subtle-day',
});

const PAGES = Object.freeze({
  COOKIE_POLICY: 'cookie_policy',
  PRIVACY_POLICY: 'privacy_policy',
  CHOOOSE_TERMS_OF_SERVICE: 'chooose_terms_of_service',
  CHOOOSE_DATA_PROTECTION: 'chooose_data_protection',
  TOGETHER: 'together',
});

const PROMISES = Object.freeze({
  SURPRISES: 'surprises',
  SAFE: 'safe',
  CONTROL: 'control',
  COOKIE: 'cookie',
});

export { namespace, AZURE_COLORS, APPS, BACKPACK_COLORS, PAGES, PROMISES, COMPONENTS };
